import {
  LIST_PROFILE_SETUP_REQUEST,
  LIST_PROFILE_SETUP_SUCCESS,
  LIST_PROFILE_SETUP_FAIL,
  CREATE_PROFILE_SETUP_REQUEST,
  CREATE_PROFILE_SETUP_SUCCESS,
  CREATE_PROFILE_SETUP_FAIL,
  DETAIL_PROFILE_SETUP_REQUEST,
  DETAIL_PROFILE_SETUP_SUCCESS,
  DETAIL_PROFILE_SETUP_FAIL,
  UPDATE_PROFILE_SETUP_REQUEST,
  UPDATE_PROFILE_SETUP_SUCCESS,
  UPDATE_PROFILE_SETUP_FAIL,
  DELETE_PROFILE_SETUP_REQUEST,
  DELETE_PROFILE_SETUP_SUCCESS,
  DELETE_PROFILE_SETUP_FAIL
} from '../../constants/user-profile-setup'

const initialState = {
  loading: false,
  profileSetups: [],
  loadingDelete: false,
  loadingCreate: false,
  profileSetup: {},
  error: null,
  pageable: {},
  twoFaStatus: false,
  twoFactorSetup: {}
}

const listProfileSetupReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_PROFILE_SETUP_REQUEST:
      return { ...state, loading: true }
    case LIST_PROFILE_SETUP_SUCCESS:
      return { ...state, loading: false, profileSetups: action.payload, pageable: action.pageable }
    case LIST_PROFILE_SETUP_FAIL:
      return { ...state, loading: false, error: action.payload, profileSetups: [] }
    case CREATE_PROFILE_SETUP_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_PROFILE_SETUP_SUCCESS:
      return { ...state, loadingCreate: false }
    case CREATE_PROFILE_SETUP_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DETAIL_PROFILE_SETUP_REQUEST:
      return { ...state, loadingCreate: true, profileSetup: {} }
    case DETAIL_PROFILE_SETUP_SUCCESS:
      return { ...state, loadingCreate: false, profileSetup: action.payload }
    case DETAIL_PROFILE_SETUP_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case UPDATE_PROFILE_SETUP_REQUEST:
      return { ...state, loadingCreate: true }
    case UPDATE_PROFILE_SETUP_SUCCESS:
      return { ...state, loadingCreate: false }
    case UPDATE_PROFILE_SETUP_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DELETE_PROFILE_SETUP_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_PROFILE_SETUP_SUCCESS:
      return { ...state, loadingDelete: false }
    case DELETE_PROFILE_SETUP_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case "TWO_FACTOR_AUTH_STATUS_REQUEST":
      return { ...state, loading: true }
    case "TWO_FACTOR_AUTH_STATUS_SUCCESS":
      return { ...state, loading: false, error: '', twoFaStatus: action.payload.isEnabled, twoFactorSetup: action.payload }
    case "TWO_FACTOR_AUTH_STATUS_FAIL":
      return { ...state, loading: false, error: action.payload }
    case "TWO_FACTOR_AUTH_SETUP_REQUEST":
      return { ...state, loadingSetup: true }
    case "TWO_FACTOR_AUTH_SETUP_SUCCESS":
      return { ...state, loadingSetup: false, error: '', twoFactorSetup: action.payload }
    case "TWO_FACTOR_AUTH_SETUP_FAIL":
      return { ...state, loadingSetup: false, error: action.payload }
    default:
      return state
  }
}

export default listProfileSetupReducer